export default function SearchIcon({ searchIconClassName }) {
  return (
    <svg
      className={searchIconClassName}
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      viewBox='0 0 22 22'>
      <path
        className={searchIconClassName}
        id='_Search_icon'
        data-name=' ↳Search icon'
        d='M20.126,22h0l-6.289-6.275V14.73l-.34-.352a8.187,8.187,0,1,1,.881-.881l.352.34h.994L22,20.126,20.127,22ZM8.176,2.516a5.66,5.66,0,1,0,5.66,5.66A5.667,5.667,0,0,0,8.176,2.516Z'
      />
    </svg>
  );
}
